<template lang="pug">
  .component-translation-edit
    .row.column.card.pt-2
      h3.text-center {{body.group}}.{{body.key}}
      loading-spinner(v-if="!allowedLanguages.length")
      .row
        .column
          label lang
        .column
          label value
      .row(v-for="(key) in allowedLanguages")
        .column.small-2.large-1.medium-1
          input(type="text", :value="key" readonly='readOnly')
        .column
          textarea(v-model="typeof body.value[key] === 'object'? JSON.stringify(body.value[key]) : body.value[key]" :name='key' rows="8")

      .row
        .column
          //.button(@click="update") Test()
          ActionButton(:action="update") Update
        .column.text-right
          TranslationButtons(:item="item", v-if="deleteButton" )


</template>

<script>
import KeplerBackofficeSdk from '../../lib/kepler/backoffice'
import MaggieHelper from "../../maggieHelper";
import ActionButton from "../../components/structure/ui/ActionButton";
import LoadingSpinner from "../../components/structure/LoadingSpinner";
import {mapState} from "vuex";
import collect from "collect.js";
import TransactionActionButtons from "../../components/structure/ui/actions/TransactionButtons.vue";
import TranslationButtons from "../../components/structure/ui/actions/TranslationButtons.vue";


export default {
  name: 'TranslationEdit',
  components: {TranslationButtons, TransactionActionButtons, LoadingSpinner, ActionButton},
  data() {
    return {
      bodyDefault: {
        group: '',
        key: '',
        value: [],
      },
      otherValues: {
        value: [],
      }

    }
  },
  created() {

  },
  methods: {
    sanitazeNullValues(obj) {
      for (const key in obj) {
        if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
          delete obj[key];
        }
      }
    },
    update() {
      this.body.group.trim()
      this.body.key.trim()
      Object.assign(this.body.value, this.otherValues.value)
      this.sanitazeNullValues(this.body.value)
      if (this.item.id !== undefined) {
        return KeplerBackofficeSdk.translations.select(this.item.id).update(this.body, (data) => {
          MaggieHelper.notification('Done', 'Translation Updated')
        })
      } else {
        return KeplerBackofficeSdk.translations.make(this.body, (data) => {
          MaggieHelper.notification('Done', 'Translation created')
        })
      }
    }
  },
  computed: {
    body: {
      get: function () {
        this.bodyDefault.group = this.item.group
        this.bodyDefault.key = this.item.key
        this.sanitazeNullValues(this.item.value)
        this.bodyDefault.value = this.item.value
        return this.bodyDefault
      },
      set: function (item) {

        this.bodyDefault.group = item.group
        this.bodyDefault.key = item.key
        this.sanitazeNullValues(item.value)
        this.bodyDefault.value = item.value
      }
    },

    ...mapState({
      configuration: state => state.configuration,
    }),
    allowedLanguages() {
      const systemFields = collect(this.configuration.system.system_fields_configuration.value);

      let config = systemFields.first((i) => i.field === 'allowedLanguages');
      if (config.field === 'allowedLanguages') {
        return  collect(this.configuration.system.system_fields_configuration.value).first((i) => i.field === 'allowedLanguages').config.split(',')
      }

      return ["en"]
    }
  },
  props: ['item', 'deleteButton']
}
</script>

<style>


</style>



// WEBPACK FOOTER //
// TranslationEdit.vue?6f0bb160